
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33.6 28.8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.832 10.051a5.026 5.026 0 10-5.13-5.025 5.079 5.079 0 005.13 5.025z","fill":"#fd6481"}}),_c('path',{attrs:{"d":"M6.233 10.051A3.261 3.261 0 102.9 6.79a3.295 3.295 0 003.333 3.261zM27.347 10.051a3.261 3.261 0 10-3.328-3.26 3.295 3.295 0 003.328 3.26zM27.363 12.343a6.347 6.347 0 00-3.776 1.249 9.212 9.212 0 012.885 6.673v4.38h4.858a2.234 2.234 0 002.27-2.19v-4.074a6.117 6.117 0 00-6.237-6.038zM6.958 20.715a9.879 9.879 0 013.055-7.123 6.373 6.373 0 00-3.755-1.249A6.149 6.149 0 000 18.381V22.5a2.234 2.234 0 002.27 2.19h4.667v-3.975z","fill":"#fea7b8"}}),_c('path',{attrs:{"d":"M25.2 26.229a2.476 2.476 0 01-2.362 2.571H10.762A2.476 2.476 0 018.4 26.229V22c0-4.949 3.4-9.394 7.947-9.634.155 0 .453-.024.442-.024 4.636 0 8.389 4.084 8.389 9.13l.022 4.242z","fill":"#fd6481"}})])
          )
        }
      }
    